import {
	Box,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogProps,
	DialogTitle,
	Divider,
	IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '../typography/typography';
import Button from '../button/button';
import './confirm-modal.scss';
import images from '../../assets/images';
import { useLanguage } from '@erpsquad/common/runtime';
import { useTranslation } from 'react-i18next';

interface ConfirmPopUpProps extends DialogProps {
	title: string;
	description: string | JSX.Element;
	onClose: () => void;
	onConfirm: () => void;
	buttonTexts?: {
		confirm: string;
		cancel: string;
	};
	buttonColors?: {
		confirm: string;
		cancel?: string;
	};
	modalType?: 'alert' | 'info';
	loading?: boolean;
	showAction?: boolean;
}

export const ConfirmPopUp = (props: ConfirmPopUpProps) => {
	const { t } = useTranslation();
	const {
		open,
		title,
		description,
		onClose,
		onConfirm,
		modalType = 'alert',
		buttonTexts = { confirm: t('common.delete'), cancel: t('common.cancel') },
		buttonColors = { confirm: 'error' },
		loading = false,
		showAction=true,
		...rest
	} = props;

	const icon = modalType === 'info' ? images.info : images.alert;
    const {isRtl}=useLanguage();
	return (
		<>
			<Dialog open={open} onClose={onClose} className='confirm' {...rest}>
				<DialogTitle className='confirm--head'>
					<Box className='confirm--title'>
						<img src={icon} alt='alert icon' />{' '}
						<Typography
							type='s3'
							ml={1}
							weight='medium'
							color='theme.secondary.1000'>
							{title}
						</Typography>
					</Box>
					<IconButton disableRipple onClick={onClose} disabled={loading}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<Divider />
				<DialogContent className='confirm--content'>
					<Typography type='s3' color='theme.secondary.1000'>
						{description}
					</Typography>
				</DialogContent>
				<Divider />
				{showAction &&<DialogActions
					className='confirm--actions'
					sx={{ backgroundColor: 'theme.secondary.200' }}>
					<Button
						variant='text'
						onClick={onClose}
						color={buttonColors?.cancel}
						disabled={loading}>
						{buttonTexts.cancel}
					</Button>
				{buttonTexts.confirm &&<Button
						color={buttonColors.confirm}
						onClick={onConfirm}
						sx={isRtl?{mr: 1}:{}}
						endIcon={loading && <CircularProgress size={18} color='inherit' />}
						disabled={loading}>
						{buttonTexts.confirm}
					</Button>}
				</DialogActions>}
			</Dialog>
		</>
	);
};

export default ConfirmPopUp;
